import { useState } from "react";
import { api } from "@/lib/api";
import { useT } from "@/lib/i18n";
import { toast } from "sonner";
import { ArrowUpRight } from "lucide-react";

export default function NewsletterForm({ source = "footer", variant = "dark" }) {
    const { t } = useT();
    const [email, setEmail] = useState("");
    const [name, setName] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (!email) return;
        setSubmitting(true);
        try {
            await api.post("/newsletter/subscribe", { email, name: name || undefined, source });
            toast.success(t("newsletter.success"));
            setEmail(""); setName("");
        } catch (err) {
            toast.error(err.response?.data?.detail || t("newsletter.error"));
        } finally {
            setSubmitting(false);
        }
    };

    const isDark = variant === "dark";
    const inputCls = `w-full bg-transparent border-b ${isDark ? "border-bone/30 focus:border-terracotta placeholder:text-bone/40 text-bone" : "border-espresso/30 focus:border-forest placeholder:text-muted2"} outline-none py-3 text-sm`;

    return (
        <form onSubmit={submit} data-testid="newsletter-form" className="space-y-4">
            <input
                data-testid="newsletter-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={t("newsletter.emailPlaceholder")}
                className={inputCls}
            />
            <input
                data-testid="newsletter-name"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder={t("newsletter.namePlaceholder")}
                className={inputCls}
            />
            <button
                type="submit"
                data-testid="newsletter-submit"
                disabled={submitting}
                className={`inline-flex items-center gap-2 px-6 py-3 text-xs uppercase tracking-widest2 font-semibold ${isDark ? "bg-terracotta text-bone hover:bg-terracotta/90" : "bg-forest text-bone hover:bg-forestDark"} disabled:opacity-50`}
            >
                {submitting ? t("newsletter.subscribing") : t("newsletter.subscribe")} <ArrowUpRight size={14} />
            </button>
        </form>
    );
}
